import { render, staticRenderFns } from "./RegistrationPayment.vue?vue&type=template&id=60fa7716&scoped=true&"
import script from "./RegistrationPayment.vue?vue&type=script&lang=js&"
export * from "./RegistrationPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fa7716",
  null
  
)

export default component.exports